import workspaceQuery from '../../../graphql/queries/supplier/SupplierBankDetailsWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/supplier/SupplierBankDetailsQuery.graphql';
import mutationQuery from '../../../graphql/mutations/supplier/SupplierMutation.graphql';
import defaultQuery from '../../../graphql/queries/supplier/SupplierDefault.graphql';

import { ALLOW_VIEW, ALLOW_EDIT } from '../../../utils/OperationPermissions';

const SupplierBankDetails = {
  type: 'Supplier',
  title: 'Supplier Bank Details',
  formTitle: 'Supplier Bank Details',
  formUrl: '/Suppliers/SupplierBankDetails/Details/',
  workspaceUrl: '/Suppliers/SupplierBankDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  defaultQuery: defaultQuery,
  update: mutationQuery,
  notificationKey: 'reference',
  screenReference: 'SUPPLIER_BANK_DETAILS',
  icon: 'bank',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default SupplierBankDetails;
